import * as React from "react";
import { casesActions } from "configs";
import {
  FormWatcherCallback,
  useCurrentCase,
  useParams,
  useDispatch
} from "duck";
import { useUpdateDisclaimerProcedureMutation } from "requests";
import { FormValues } from "./types";

export const useUpdateDisclaimerProcedure = () => {
  const { id } = useParams();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);
  const dispatch = useDispatch();
  const [update] = useUpdateDisclaimerProcedureMutation({
    ignoreResults: true
  });
  return React.useCallback<FormWatcherCallback<FormValues>>(
    values => {
      if (values.procedure) {
        dispatch(
          casesActions.updateDisclaimerProcedure({
            _id: id,
            data: { procedureId: +values.procedure || values.procedure }
          })
        );
        if (shouldSync) {
          return update({
            variables: { input: { _id: +values.procedure, selected: true } }
          });
        }
      }
    },
    [update, shouldSync]
  );
};
